module.exports = __webpack_public_path__ + "static/media/08.Fly.e56a2ea6.svg";